/** Name of the feature. */
export const SolanaSignMessage = 'solana:signMessage';
//# sourceMappingURL=signMessage.js.map